import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    applicationPermission: [],
    menuPermission: {},
    pagePermission: {},
    menu:[],
    routes:[]
};

export const permissionSlice = createSlice({
    name: "permission",
    initialState,
    reducers: {
        setCurrentPagePermission: (state, action) => {
            state.pagePermission = action.payload;
        },
        resetCurrentPagePermission: (state) => {
            state.pagePermission = initialState.pagePermission;
        },
        setApplicationPermission: (state, action) => {
            state.applicationPermission = action.payload.permission;
            state.menu = action.payload.menu;
            state.routes = action.payload.routes;
            try {
                localStorage.setItem(
                    'wavicle_user_permissions',
                    JSON.stringify({
                        permissions: action.payload.permission,
                        menu: action.payload.menu,
                        roleId: action.payload.roleId,
                    })
                );
            } catch (_) {}
        },
        resetApplicationPermission: (state, action) => {
            state.applicationPermission = initialState.applicationPermission;
            try { localStorage.removeItem('wavicle_user_permissions'); } catch (_) {}
        },
        setMenuPermission: (state, action) => {
            const currentPagePermission = action.payload.currentMenuPermissions.otherRoutes[action.payload.processedPath]?.permissions || {};
            state.pagePermission = currentPagePermission;
            state.menuPermission = action.payload.currentMenuPermissions;
        },
        resetMenuPermission: (state, action) => {
            state.pagePermission = initialState.pagePermission;
        },
    },
});

export const { setCurrentPagePermission, resetCurrentPagePermission, setApplicationPermission, resetApplicationPermission, setMenuPermission, resetMenuPermission } = permissionSlice.actions;

export default permissionSlice.reducer;
